import { ContactInfo } from './contact-info/ContactInfo'
import { PersonalInfo } from './personal-info/PersonalInfo'
import { CompanyInfo } from './company-info/CompanyInfo'

function ProfilePage() {
  return (
    <>
      <ContactInfo />
      <PersonalInfo />
      <CompanyInfo />
    </>
  )
}

export default ProfilePage
